<template>
  <div class="auto-scroll" @mouseenter="mouseenter" @mouseleave="mouseleave">
    <div v-if="isOver"
      :class="['content', Math.abs(y1) < contentH - step && 'isAnimation']"
      :style="{transform: `translateY(${y1}px)`}">
      <slot></slot>
    </div>
    <div :class="['content', Math.abs(y2) < contentH - step && 'isAnimation']"
      ref="contents"
      :style="{transform: `translateY(${y2}px)`}">
      <slot></slot>
    </div>
    <div v-if="isOver"
      :class="['content', Math.abs(y3) < contentH - step && 'isAnimation']"
      :style="{transform: `translateY(${y3}px)`}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    height: { type: Number, default: 0 }, // 可视盒子高度
    step: { type: Number, default: 0 }, // 一次滚动高度
    counts: { type: Number, default: 0 }, // 列表个数
    duation: { type: Number, default: 1500 } // 间隔时间
  },
  data () {
    return {
      contentH: 0, // 内容高度
      current: 0, // 当前行
      top: 0,
      isOver: false, // 是否超出一屏
      timer: null,

      y1: 0,
      y2: 0,
      y3: 0
    }
  },
  watch: {
    counts () {
      this.$nextTick(() => {
        this.init()
      })
    },
    top () {
      this.y1 = this.setY(this.y1)
      this.y2 = this.setY(this.y2)
      this.y3 = this.setY(this.y3)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init () {
      if (this.counts <= 0) return
      clearInterval(this.timer)

      this.contentH = this.$refs.contents.offsetHeight
      this.y1 = -(this.contentH)
      this.y3 = this.contentH
      this.run()
    },

    run () {
      if (this.contentH <= this.height) { // 可展示完全 无需滚动
        this.isOver = false
        return
      }
      this.isOver = true
      this.timer = setInterval(() => {
        if (Math.abs(this.top) >= this.contentH) {
          this.current = 0
        } else {
          this.current++
        }
        this.top = this.current * this.step
      }, this.duation || 1500)
    },

    setY (y) {
      // 三个内容块位置循环
      if (y < 0 && Math.abs(y) >= this.contentH) return this.contentH - this.step
      return y - this.step
    },

    mouseenter () {
      clearInterval(this.timer)
    },

    mouseleave () {
      this.run()
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="less" scoped>
.auto-scroll{
  position: relative;
  .content{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    &.isAnimation{
      width: 100%;
      transition: transform 0.4s;
    }
  }
}
</style>
